import React from "react"
import styled, { css } from "styled-components"
import { Link } from "gatsby"
import { GroupWrap } from "components/group-wrap/group-wrap"
import { Text } from "components/text/Text"
import { AppRoute } from "app/app.route.const"
import { colors } from "styles/colors"
import { useBreakpoints } from "src/lib/hooks/use-breakpoints"
import { Stack } from "components/stack/stack"
import { SocialButtons } from "./SocialButtons"

const Container = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
  width: 100%;
`

const FooterStripContainer = styled(GroupWrap) <{ maxMobileLarge: boolean }>`
  justify-content: ${({maxMobileLarge}) => maxMobileLarge ? 'center' : ''};
  .footer-strip-container {
    flex: ${({maxMobileLarge}) => maxMobileLarge ? '' : 1};
    &:nth-child(2) {
      display: flex;
      justify-content: flex-end;
      flex: 1;
    }
  }
`

const SocialButtonWrapperBottom = styled.div`
  margin-top: 1rem;
  display: flex;
  width: 100%;
  justify-content: center;
`

const FooterPulledRight = styled(Stack) <{ maxMobileLarge: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-end;
  justify-content: center;
  color: ${colors.primary};
  text-align: ${(maxMobileLarge) => maxMobileLarge ? 'center' : ''};
`

const TutorSpace = styled.div`
  font-family: "Permanent Marker", "Open Sans", -apple-system,
    BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
    sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    "Noto Color Emoji";
  font-size: 22px;
  margin: 0 8px 0 8px;
`

const FooterLink = styled(Link)``

const FooterLinkWrapper = styled.div`
  ${({ maxMobileLarge }: { maxMobileLarge: boolean }) =>
    !maxMobileLarge
      ? ""
      : css`
          min-width: 200px;
        `}
`

export const FooterStrip: React.FC = () => {
  const { maxMobileLarge } = useBreakpoints()

  return (
    <Container>
      <FooterStripContainer gap={0.5} classes="footer-strip-container" maxMobileLarge={maxMobileLarge}>
        <Stack
          gap={0.5}
          flow="row"
          justifyContent="start"
          alignItems="center"
          textAlign={maxMobileLarge ? 'center' : 'start'}
        >
          <TutorSpace>TutorSpace</TutorSpace>
          <Text style={{ margin: '0 8px 0 8px' }}>Copyright @ 2021 TutorSpace GmbH</Text>
        </Stack>
        <FooterPulledRight gap={0.5} maxMobileLarge={maxMobileLarge}>
          {!maxMobileLarge && <SocialButtons />}
          <GroupWrap gap={1} style={{ justifyContent: maxMobileLarge ? 'center' : 'flex-end'}}>
            <FooterLinkWrapper maxMobileLarge={maxMobileLarge}>
              <FooterLink
                to={`https://tutorspace.de${AppRoute.FooterImpressum}`}
              >
                <Text size={14} fontWeight={600}>
                  Impressum
                </Text>
              </FooterLink>
            </FooterLinkWrapper>
            <FooterLinkWrapper maxMobileLarge={maxMobileLarge}>
              <FooterLink to={`https://tutorspace.de${AppRoute.FooterTOS}`}>
                <Text size={14} fontWeight={600}>
                  Nutzungsbedingungen
                </Text>
              </FooterLink>
            </FooterLinkWrapper>
            <FooterLinkWrapper maxMobileLarge={maxMobileLarge}>
              <FooterLink
                to={`https://tutorspace.de${AppRoute.FooterDataProtection}`}
              >
                <Text size={14} fontWeight={600}>
                  Datenschutz
                </Text>
              </FooterLink>
            </FooterLinkWrapper>
          </GroupWrap>
          {maxMobileLarge && (
            <SocialButtonWrapperBottom>
              <SocialButtons />
            </SocialButtonWrapperBottom>
          )}
        </FooterPulledRight>
      </FooterStripContainer>
    </Container>
  )
}
